/* eslint-disable operator-linebreak */
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import * as moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/tl-ph';
import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { getNavigationalWindowObject } from '../../../AppUtil/AppUtil';
import { toastWhenWindowClose } from '../../../SweetAlertUtil/util';
import { hot } from 'react-hot-loader';

class index extends Component {
	// NOSONAR

	redirectToPage = href => {
		this.props.history.push(href);
		this.props.setInitialScreen();
		this.props.handleNotificationClose();
	};

	onStopingUserToStay = href => {
		if (getNavigationalWindowObject()) {
			this.props.handleNotificationClose();
			const store = getNavigationalWindowObject();
			toastWhenWindowClose(store, this.redirectToPage, href);
		} else {
			this.redirectToPage(href);
		}
	};

	getRandomColor = str => {
		const hash = str.charCodeAt(0) % 16777215;
		const color = Math.floor(Math.abs(Math.sin(hash) * 16777215) % 16777215).toString(16);
		return `#${color}`;
	};

	getNotifications = () => {
		if (this.props.isNotificationLoad) {
			return (
				<ListItem alignItems="flex-start">
					<ListItemText primary={this.props.t('label.loading')} />
				</ListItem>
			);
		} else {
			if (this.props.notificationData.length > 0) {
				return this.props.notificationData.slice(0, this.props.listSize).map((notifyObject, i) => {
					const randomColor = this.getRandomColor(notifyObject.first_name.charAt(0).toUpperCase());

					const linkify = text => {
						const urlPattern = /(https?:\/\/[^\s.]+[^\s]*[^.\s])/g;
						return text.replace(
							urlPattern,
							url => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
						);
					};

					const bodyWithLinks = linkify(notifyObject.body);

					return (
						<>
							<ListItem
								alignItems="flex-start"
								className="cursor-list"
								key={`notification-${i}`}
								// onClick={() => {
								// this.onStopingUserToStay(notifyObject.href);
								// }}
							>
								<ListItemAvatar>
									<Avatar alt="Aemy Sharp" style={{ backgroundColor: randomColor }}>
										{notifyObject.first_name.charAt(0).toUpperCase() +
											notifyObject.last_name.charAt(0).toUpperCase()}
									</Avatar>
								</ListItemAvatar>
								<ListItemText
									className="notification-list-container"
									primary={<div dangerouslySetInnerHTML={{ __html: bodyWithLinks }} /> || ''}
									secondary={
										<Typography
											className="notificatin-list"
											color="textPrimary"
											component="span"
											variant="body2">
											{(() => {
												if (this.props.i18n.language === 'en-US') {
													moment.locale('en-gb');
												} else if (this.props.i18n.language === 'es-ES') {
													moment.locale('es');
												} else if (
													this.props.i18n.language === 'ceb' ||
													this.props.i18n.language === 'tl'
												) {
													moment.locale('tl-ph');
												}
											})()}
											{moment(notifyObject.created_at).format('MMM-DD-YYYY, h:mm A') || ''}
										</Typography>
									}
								/>
							</ListItem>
							<Divider component="li" variant="inset" />
						</>
					);
				});
			} else {
				return (
					<ListItem alignItems="flex-start">
						<ListItemText primary={this.props.t('label.no_new_notification')} />
					</ListItem>
				);
			}
		}
	};

	render() {
		return (
			<div>
				<Popover
					anchorEl={this.props.anchorEl}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center'
					}}
					id="simple-popover"
					onClose={this.props.handleNotificationClose}
					open={Boolean(this.props.anchorEl)}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'center'
					}}>
					<List>{this.getNotifications()}</List>
					{this.props.listSize !== this.props.notificationData.length &&
					this.props.notificationData.length > 0 ? (
						<ListItem alignItems="center" button onClick={this.props.setListSize}>
							<ListItemText
								alignItems="center"
								id="center"
								secondary={this.props.t('buttons.view_all')}
							/>
						</ListItem>
					) : null}
				</Popover>
			</div>
		);
	}
}

export default withRouter(hot(module)(withTranslation()(index)));
